import(/* webpackMode: "eager" */ "/Users/gopal/BlindsCode/blindscommerce/app/guides/measuring-bay-windows/page.tsx");
